import { useRef } from "react"
import { Formik, Field, Form } from "formik"
import {
  InputGroup,
  Label,
  Wrapper,
  CombineInputGroup,
  SubmitBtn,
} from "../../Styles/InputStyles"
import tw from "tailwind-styled-components"
import { FormControl, Select, MenuItem } from "@mui/material"
import * as Yup from "yup"

const PropertySpecs = ({
  editInventorySpecsLoading,
  editInventorySpecsMutate,
  apiData
}) => {

  const formikRef = useRef(null)

  const bathroomTypeOptions = [
    { label: "Attached", value: 1 },
    { label: "Common", value: 2 },
    { label: "Both", value: 3 },
  ]

  const inventoryAgeOptions = [
    { label: "New", value: "NEW" },
    { label: "1 Year Old", value: "1Y" },
    { label: "2 Years Old", value: "2Y" },
    { label: "3+ Years Old", value: "3Y_PLUS" },
  ]

  const parkingOptions = [
    { label: "No Parking", value: 0 },
    { label: "Bike Parking", value: 1 },
    { label: "Car Parking", value: 2 },
    { label: "Both", value: 3 },
  ]

  const furnishedOptions = [
    { label: "Fully Furnished", value: 1 },
    { label: "Semi Furnished", value: 2 },
    { label: "Unfurnished", value: 3 },
  ]

  const foodPreferenceOptions = [
    { label: "Veg", value: 1 },
    { label: "Non-Veg", value: 2 },
    { label: "Whatever", value: 3 },
  ]

    const validationSchema = Yup.object({
        // age: Yup.string()
        //     .required("Select the inventory age"),
        // parking: Yup.string().required("Select the parking")    
    });

  const initialValues = {
    noOfBathroom: apiData?.noOfBathroom || "",
    bathroomTypes: apiData?.bathroomTypes || "",
    noOfBalcony: apiData?.noOfBalcony || "",
    // floorNumber: apiData?.floorNumber || "",
    totalFloors: apiData?.totalFloors || "",

    carpetArea: apiData?.carpetArea || "",
    buildUpArea: apiData?.buildUpArea || "",
    age: apiData?.age || "",
    parking: apiData?.parking ?? "",
    furnishingType: apiData?.furnishingType || "",
    tenantPreference: apiData?.tenantPreference || "",
    foodPreference: apiData?.foodPreference || "",
  }

  const handleSubmit = (values) => {

    editInventorySpecsMutate({
      inventoryId: apiData?.id,

      noOfBathroom: values.noOfBathroom || "",
      bathroomTypes: values.bathroomTypes || "",
      noOfBalcony: values.noOfBalcony || "",
      // floorNumber: Number(values.floorNumber || 0),
      totalFloors: values.totalFloors || "",
      carpetArea: values.carpetArea || "",
      buildUpArea: values.buildUpArea || "",
      age: values.age || "",
      parking: values.parking || "",
      furnishingType: values.furnishingType || "",
      //tenantPreference: values.tenantPreference || "",
      foodPreference: values.foodPreference || "",
    })
  }

  const getInputClass = () =>
    "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12"

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ values, setFieldValue,errors, touched }) => (
        <Form>
          <Wrapper>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="age">Inventory Age</Label>
                <FormControl fullWidth>
                  <Select
                    name="age"
                    id="age"
                    className="px-2"
                    value={values.age}
                    onChange={(e) =>
                      setFieldValue("age", e.target.value)
                    }
                    displayEmpty
                    sx={{ height: "46px" }}
                  >
                    <MenuItem value="" disabled>
                      <span className="text-gray-400">Select age</span>
                    </MenuItem>
                    {inventoryAgeOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {touched.age && errors.age && (
                    <p className="text-rose-600 text-sm mt-1">
                        {errors.age}
                    </p>
                )}
              </InputGroup>

              <InputGroup>
                <Label htmlFor="parking">Parking Available</Label>
                <FormControl fullWidth>
                  <Select
                    className="px-2"
                    value={values.parking}
                    onChange={(e) => setFieldValue("parking", e.target.value)}
                    displayEmpty
                    sx={{ height: "46px" }}
                  >
                    <MenuItem value="" disabled>
                      <span className="text-gray-400">Select parking</span>
                    </MenuItem>
                    {parkingOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {touched.parking && errors.parking && (
                    <p className="text-rose-600 text-sm mt-1">
                        {errors.parking}
                    </p>
                )}
              </InputGroup>
            </CombineInputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="carpetArea">Carpet Area (sqft)</Label>
                <Field
                  type=""
                  name="carpetArea"
                  id="carpetArea"
                  className={getInputClass()}
                  onKeyDown={(e) => {
                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault();
                    }
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="buildUpArea">Built-up Area (sqft)</Label>
                <Field
                  type=""
                  name="buildUpArea"
                  id="buildUpArea"
                  className={getInputClass()}
                  onKeyDown={(e) => {
                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault();
                    }
                  }}
                />
              </InputGroup>
            </CombineInputGroup>

            {/* noOfBathroom + Bathroom Type */}
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="noOfBathroom">No. of Bathrooms</Label>
                <Field
                  type=""
                  name="noOfBathroom"
                  id="noOfBathroom"
                  className={getInputClass()}
                  onKeyDown={(e) => {
                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault();
                    }
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="bathroomTypes">Bathroom Type</Label>
                <FormControl fullWidth>
                  <Select
                    className="px-2"
                    name="bathroomTypes"
                    id="bathroomTypes"
                    value={values.bathroomTypes}
                    onChange={(e) =>
                      setFieldValue("bathroomTypes", e.target.value)
                    }
                    displayEmpty
                    sx={{ height: "46px" }}
                  >
                    <MenuItem value="" disabled>
                      <span className="text-gray-400">
                        Select bathroom type
                      </span>
                    </MenuItem>
                    {bathroomTypeOptions.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </InputGroup>
            </CombineInputGroup>

            {/* Balcony + Floors */}
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="noOfBalcony">No. of Balconies</Label>
                <Field
                  type=""
                  name="noOfBalcony"
                  id="noOfBalcony"
                  className={getInputClass()}
                  onKeyDown={(e) => {
                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault();
                    }
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="totalFloors">Total Floors</Label>
                <Field
                  type=""
                  name="totalFloors"
                  id="totalFloors"
                  className={getInputClass()}
                  onKeyDown={(e) => {
                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault();
                    }
                  }}
                />
              </InputGroup>
            </CombineInputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="furnishingType">Interior Type</Label>
                <FormControl fullWidth>
                  <Select
                    name="furnishingType"
                    id="furnishingType"
                    className="px-2" 
                    value={values.furnishingType}
                    onChange={(e) =>
                      setFieldValue("furnishingType", e.target.value)
                    }
                    displayEmpty
                    sx={{ height: "46px" }}
                  >
                    <MenuItem value="" disabled>
                      <span className="text-gray-400">Select interior type</span>
                    </MenuItem>
                    {furnishedOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {touched.furnishingType && errors.furnishingType && (
                    <p className="text-rose-600 text-sm mt-1">
                        {errors.furnishingType}
                    </p>
                )}
              </InputGroup>

              <InputGroup>
                <Label htmlFor="foodPreference">Food Preference</Label>
                <FormControl fullWidth>
                  <Select
                    className="px-2"
                    value={values.foodPreference}
                    onChange={(e) => setFieldValue("foodPreference", e.target.value)}
                    displayEmpty
                    sx={{ height: "46px" }}
                  >
                    <MenuItem value="" disabled>
                      <span className="text-gray-400">Select food preference</span>
                    </MenuItem>
                    {foodPreferenceOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {touched.foodPreference && errors.foodPreference && (
                    <p className="text-rose-600 text-sm mt-1">
                        {errors.foodPreference}
                    </p>
                )}
              </InputGroup>
            </CombineInputGroup>

          </Wrapper>

          <BtnWrapper>
            <SubmitBtn type="submit" disabled={editInventorySpecsLoading}
             className="text-sm  w-24  md:w-20 h-7 md:text-xs"
            >
              {editInventorySpecsLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </Form>
      )}
    </Formik>
  )
}


const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`

export default PropertySpecs ;


